var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockableIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_971_30304)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 6.66671H14.1666V5.00004C14.1666 2.70004 12.2999 0.833374 9.99992 0.833374C7.69992 0.833374 5.83325 2.70004 5.83325 5.00004V6.66671H4.99992C4.08325 6.66671 3.33325 7.41671 3.33325 8.33337V16.6667C3.33325 17.5834 4.08325 18.3334 4.99992 18.3334H14.9999C15.9166 18.3334 16.6666 17.5834 16.6666 16.6667V8.33337C16.6666 7.41671 15.9166 6.66671 14.9999 6.66671ZM9.99992 14.1667C9.08325 14.1667 8.33325 13.4167 8.33325 12.5C8.33325 11.5834 9.08325 10.8334 9.99992 10.8334C10.9166 10.8334 11.6666 11.5834 11.6666 12.5C11.6666 13.4167 10.9166 14.1667 9.99992 14.1667ZM12.5833 6.66671H7.41658V5.00004C7.41658 3.57504 8.57492 2.41671 9.99992 2.41671C11.4249 2.41671 12.5833 3.57504 12.5833 5.00004V6.66671Z",
    fill: "#595869"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_971_30304"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockableIcon);
export default __webpack_public_path__ + "static/media/lockable-icon.b3390fdaf6755f688e903a7cbdfce853.svg";
export { ForwardRef as ReactComponent };